import { Pressable, View } from 'react-native';

import { HStack, Text, VStack } from '@squire/ui';

import { ChevronDownIcon } from '@/components/_icons';

import { CookieItemCard } from './CookieItemCard';
import { styles } from './styles';
import type { Tracker } from './types';

type TrackerDetailsProps = {
  tracker: Tracker;
  onGoBack: () => void;
};

const TrackerDetails = ({ tracker, onGoBack }: TrackerDetailsProps) => {
  return (
    <VStack style={styles.detailsContainer}>
      <HStack style={styles.detailsHeader}>
        <Pressable
          onPress={onGoBack}
          style={styles.backButton}
          testID="tracker-back-button"
        >
          <View style={styles.backArrow}>
            <ChevronDownIcon size={16} color="textPrimaryInverse" />
          </View>
        </Pressable>
        <Text
          variant="m"
          color="textPrimaryInverse"
          style={styles.detailsTitle}
        >
          {tracker.name}
        </Text>
      </HStack>

      <VStack style={styles.cookieItemsContainer} id="cookie-items-scroll-view">
        {tracker.items.map((item) => (
          <CookieItemCard key={item.name} item={item} />
        ))}
      </VStack>
    </VStack>
  );
};

TrackerDetails.displayName = 'TrackerDetails';

export { TrackerDetails };
